import {put, take, call, fork} from 'redux-saga/effects'
import {get, post} from '../fetch/fetch'
import { GET_NODES,GET_SELF_AREA,AGENT_GET_PROJECT_LIST,AGENT_CURRENT_GET,GET_PROJ_SELF_AREA } from '@/fetch/url'
import { GET_AREA,COMPANY_GET_PROJECT_LIST,PLATFORM_GET_PROJECT } from '@/fetch/url'
import {actionsTypes as IndexActionTypes} from '../reducers'
import {actionTypes as DevActionTypes} from '../reducers/devManagerReducer'

export function* getTreeNodes(type,url) {
    yield put({type: IndexActionTypes.FETCH_START});
    try {
        return yield call(get, url)
    } catch (error) {
        yield put({type:IndexActionTypes.SET_MESSAGE,msgContent:'获取信息失败',msgType:0});
    } finally {
        yield put({type: IndexActionTypes.FETCH_END});
    }
}

export function* getTreeNodesFlow () {
    while (true){
        let req = yield take(DevActionTypes.LOAD_TREE);
        let type = req.data.type;
        let id = req.data.id;
        let role = req.data.userRole;
        let url = getUrlByType(type,id,role);
        let res = yield call(getTreeNodes,type,url);
        if(res && res.success){
            if(res.content != null){
                let data = {
                    id:id,
                    type:type,
                    content:convertList(res.content.list?res.content.list:res.content,type)
                }
                yield put({type: DevActionTypes.LOAD_TREE_RESPONSE,data:data});
            }else{
                yield put({type: IndexActionTypes.SET_MESSAGE, msgContent: "error", msgType: 0});
            }
        }
    }
}

function getUrlByType(type,id,role) {
    var url = '';
    if(type == 'areaTree') {
        if (role == 'PLATFORM') {
            url = GET_AREA +'?pid=' + id
        } else {
            url = GET_PROJ_SELF_AREA +'?pid=' + id
        }
    } else if(type == 'agentTree') {
        url = AGENT_CURRENT_GET + '?id=' + id
    } else if(type == 'projectTree') {
        if (role == 'ENTERPRISE') {
            url = COMPANY_GET_PROJECT_LIST + '?page=1&limit=999'
        } else if (role == 'AGENTS') {
            url = AGENT_GET_PROJECT_LIST + '?page=1&limit=999'
        } else if (role == 'PLATFORM') {
            url = PLATFORM_GET_PROJECT + '?pid=' + id
        }
    }
    return url
}

function convertList(list,type) {
    let newList = [];

    for(var i = 0;i<list.length;i++) {
        let name = '';
        if(type == 'areaTree') {
            name = list[i].name
        } else if(type == 'agentTree') {
            name = list[i].userName
        } else if(type == 'projectTree') {
            name = list[i].name
        }
        newList.push({
            title:name,
            id:list[i].id,
            isLeaf:list[i].children?false:true,
            filtertype:list[i].type == null?'': list[i].type
        })
    }
    return newList
}




// WEBPACK FOOTER //
// ./src/sagas/devManagerSaga.js